import React, { memo } from "react";
import Form from "react-bootstrap/Form";
import DropdownMain from "../../../../../components/dropdown-main/DropdownMain";
import { TriyoForm } from "../../../../../components/TriyoForm";
import { priorityValues } from "../template-task-utility";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormTopNew = ({
  isSubtask,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  setFieldValue,
  setFieldTouched,
  taskTypes,
  templateName
}) => {
  return (
    <>
      <div className="template-task-form-container">
        <div className="template-task-left-sub-panel">
          <Form.Group className="project-dropdown-container">
            <Form.Label>
              Project Template<span style={{ color: "red" }}> * </span>
            </Form.Label>
            <Form.Control
              className="template-task-dropdown-selector"
              name="ProjectTemplate"
              value={templateName}
              disabled={true}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="template-task-name">
            <Form.Label>
              Task Name
              {!isSubtask && <span style={{ color: "red" }}> * </span>}
            </Form.Label>
            <Form.Control
              id="Name"
              name="Name"
              value={values.Name}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={handleBlur}
              placeholder="Enter Task Name"
              disabled={isSubtask}
              isInvalid={touched.Name && errors.Name}
            />
            <Form.Control.Feedback type="invalid" className="inline-error">
              {errors.Name}
            </Form.Control.Feedback>
          </Form.Group>
        </div>

        <div className="template-task-right-sub-panel">
          <Form.Group className="template-task-right-dropdown">
            <Form.Label>
              Priority <span style={{ color: "red" }}> * </span>
            </Form.Label>
            <DropdownMain
              values={priorityValues}
              dropdownButtonText={"-Select-"}
              onSelect={(selectedValue) => {
                setFieldValue("Priority", selectedValue.id);
                setFieldTouched("Priority");
              }}
              currentSelected={priorityValues.find(
                (val) => parseInt(val.id) === parseInt(values.Priority)
              )}
            />
            {!values.Priority && touched.Priority && (
              <div type="invalid" className="inline-error priority-error">
                {errors.Priority}
              </div>
            )}
          </Form.Group>

          <Form.Group className="template-task-left-dropdown">
            <Form.Label>
              Task Type <span style={{ color: "red" }}> * </span>
            </Form.Label>
            <DropdownMain
              values={taskTypes}
              dropdownButtonText={"-Select-"}
              onSelect={(selectedValue) => {
                setFieldValue("WorkItemTypeId", selectedValue.id);
                setFieldTouched("WorkItemTypeId");
              }}
              currentSelected={taskTypes.find(
                (val) => val.id === values.WorkItemTypeId
              )}
            />
            {!values.WorkItemTypeId && touched.WorkItemTypeId && (
              <div type="invalid" className="inline-error">
                {errors.WorkItemTypeId}
              </div>
            )}
          </Form.Group>
        </div>
      </div>

      <TriyoForm.Divider />
    </>
  );
};

TemplateTaskCreationPanelFormTopNew.propTypes = {
  isSubtask: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  taskTypes: PropTypes.array.isRequired,
  templateName: PropTypes.string.isRequired
};
export default memo(TemplateTaskCreationPanelFormTopNew);
